// This file uses js and commonjs to be compatible with tailwind config

// Prepare colors for usage in tailwind config and as css variables
module.exports = function prepareColorVariables(jsonColors) {
  const tailwindConfig = {}
  const cssVariables = {}

  for (let [colorName, shades] of Object.entries(jsonColors)) {
    let tailwindColor = {}

    if (typeof shades === "string") {
      shades = { DEFAULT: shades }
    }

    for (let [shade, color] of Object.entries(shades)) {
      let variableName = `--color-${colorName}`
      if (shade !== "DEFAULT") variableName += `-${shade}`

      tailwindColor[shade] = `var(${variableName})`
      cssVariables[variableName] = color
    }

    tailwindConfig[colorName] = tailwindColor
  }

  return { tailwindConfig, cssVariables }
}
